import { useInfiniteQuery } from '@tanstack/react-query';
import api from '../../api/client';
import { queryKeys } from './queryKeys';
import useProtectedQueryEnabled from './useProtectedQueryEnabled';

export const GALLERY_PAGE_SIZE = 24;

export async function fetchGalleryPage(
  { filter = 'all', limit = GALLERY_PAGE_SIZE, offset = 0 },
  signal,
) {
  const res = await api.get('/gallery', {
    params: { type: filter, limit, offset },
    signal,
  });
  return {
    items: res?.data?.items || [],
    total: Number(res?.data?.total || 0),
    limit,
    offset,
  };
}

export function galleryInfiniteQueryOptions(filter, { enabled = true } = {}) {
  return {
    queryKey: queryKeys.gallery(filter),
    queryFn: ({ pageParam = 0, signal }) =>
      fetchGalleryPage({ filter, limit: GALLERY_PAGE_SIZE, offset: pageParam }, signal),
    enabled,
    initialPageParam: 0,
    getNextPageParam: (lastPage) => {
      const nextOffset = Number(lastPage?.offset || 0) + (lastPage?.items?.length || 0);
      const total = Number(lastPage?.total || 0);
      return nextOffset < total ? nextOffset : undefined;
    },
  };
}

export function useGalleryInfiniteQuery(filter, { enabled = true } = {}) {
  const protectedEnabled = useProtectedQueryEnabled(enabled);
  return useInfiniteQuery(galleryInfiniteQueryOptions(filter, {
    enabled: protectedEnabled,
  }));
}
